var _react_refresh_temp_1;
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Trans, Typography } from '@lucidlink/uicore';
import { GuestLinkEntry } from './GuestLinkEntry';
export const GuestLinksList = ({ links, linksCount, onRemove, pathQueriesByEntryId, }) => (_jsxs(_Fragment, { children: [_jsx(Typography, { color: "accent", kind: "label", children: _jsxs(Trans, { children: ["Added to links (", { linksCount }, ")"] }) }), _jsx(Box, { gap: "xs", isFullWidth: true, orientation: "vertical", scrollableY: true, children: links.map((link) => {
                const pathQuery = pathQueriesByEntryId[link.fsEntryId];
                if (!pathQuery) {
                    return null;
                }
                return (_jsx(GuestLinkEntry, { isOptimistic: link.isOptimistic, link: link, onRemove: () => onRemove(link), pathQuery: pathQuery }, link.id));
            }) })] }));
_react_refresh_temp_1 = GuestLinksList;
$RefreshReg$(_react_refresh_temp_1, "GuestLinksList");
